import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class JwtService {
  private token;

  constructor(private http: HttpClient) { }

  async setJwtToken(token: string) {
    this.token = token;
    await this.testJwtToken();
  }

  setGlobalToken(token: string) {
    sessionStorage.setItem('GlobalToken', token);
  }

  getJWThttpHeaders(global?: boolean) {
    const token = global ? this.globalToken : this.token;
    return new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Authorization: `Bearer ${token}`,
        Expires: 'Sat, 01 Jan 2000 00:00:00 GMT'
      });
  }

  async generateToken(AGSToken: string): Promise<void> {
    await this.buildGlobalJWTToken().then(res => {
      return this.setGlobalToken(res.token);
    });

    await this.buildJWTToken(AGSToken).then(res => {
      return this.setJwtToken(res.token);
    });
  }

  async buildJWTToken(AGSToken: string) {
    return await this.http.get(environment.api + '/JWT/SetUpJWTSecurity/' + AGSToken)
    .toPromise()
    .then((response: any) => {
      return response;
    }).catch(err => {
      console.warn(err);
      return;
    });
  }

  async buildGlobalJWTToken() {
    const portalToken = sessionStorage.getItem('PortalToken');
    // tslint:disable-next-line: max-line-length
    return this.http.get(`${environment.gapi_root}JWT/CreateJWTToken?portalToken='${portalToken}'&appID=SAFETY&Globalflag=true`).toPromise()
    .then((response: any) => {
      return response;
    }).catch(err => {
      console.warn(err);
      return;
    });
  }


async testJwtToken(): Promise<void> {
  return await this.http.post(environment.api + '/JWT/TestAuth', null, { headers: this.getJWThttpHeaders() })
  .toPromise()
  .then((response: string) => {
    console.log('Test JWT response:', response);
    return;
  }).catch(err => {
    console.warn(err);
    return null;
  });
}

get globalToken() {
  return sessionStorage.getItem('GlobalToken');
}

get portalToken() {
  return sessionStorage.getItem('PortalToken');
}

}
